import * as yup from "yup";

import { validator as companyDetailsDataValidator } from "./CompanyData/validator";
import { validator as generalDataValidator } from "./GeneralData/validator";
import { validator as ownerDetailsDataValidator } from "./OwnerDetails/validator";
import { validator as perpetratorDataValidator } from "./PerpetratorData/validator";

export const validator = yup.object({
  ...generalDataValidator,
  ...perpetratorDataValidator,
  ...ownerDetailsDataValidator,
  ...companyDetailsDataValidator,
});
